document.addEventListener("DOMContentLoaded", function () {
    initializeSwiper();
    initSwiperDeals();
  });
  
  function initializeSwiper() {
    new Swiper("#main-banner .swiper", {
      loop: true,
  
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });
  }

  function initSwiperDeals() {
    new Swiper("#offers .swiper", {
      loop: true,
      slidesPerView: 1,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
 